import { render, staticRenderFns } from "./veStuAssocFundsEdit.vue?vue&type=template&id=ba52e8be&scoped=true"
import script from "./veStuAssocFundsEdit.vue?vue&type=script&lang=js"
export * from "./veStuAssocFundsEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba52e8be",
  null
  
)

export default component.exports